import type { FaireProductEntity } from "../../entity_types/product";

export const p_gfec8kcd76: FaireProductEntity = {
  token: "p_gfec8kcd76",
  type: "product",
  name: "LM-BG-1003 TOTE BAG LT PINK/LT BLUE STRIPE",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/7ef6d300832342dcb168604e2c25daddedca01ab5d733cca8b5c732baad0fa8a.png",
  galleryImageUrls: [],
  priceDollars: 15,
  description: "This Girlie Girl Originals tote bag features a light pink and light blue stripe design that complements outings. It has shoulder straps and an open top for access, making it suitable for errands or beach use.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:13.770Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
